import { render, staticRenderFns } from "./TeamGoalTable.vue?vue&type=template&id=69e472da&scoped=true"
import script from "./TeamGoalTable.vue?vue&type=script&lang=ts"
export * from "./TeamGoalTable.vue?vue&type=script&lang=ts"
import style0 from "./TeamGoalTable.vue?vue&type=style&index=0&id=69e472da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e472da",
  null
  
)

export default component.exports